module.exports = __webpack_public_path__ + "media/images/redesign-images/misc/nav-image-custom-collective-dc87aaeb365aa919c34a26d3275f0471.jpg";